import { Component, Input, OnInit } from "@angular/core";
import { IBodyCell, BodyCell } from '../../holders/body-cell.component';

@Component({
   selector: "exi-text",
   template: `
      {{ string }}
   `,
   styleUrls: ["./text.component.scss"]
})
export class TextCellComponent<D> implements IBodyCell<D> , OnInit {
   @Input() cell: TextCell<D>;
   @Input() value: D;
   public string: string;

   ngOnInit() {
      this.string = this.cell.get(this.value);
   }

   getValueForSearcher() {
      return this.cell.get(this.value);
   }
}


export class TextCell<D> extends BodyCell<D> {
   constructor(
      public get: (row: D) => string
   ) {
      super(TextCellComponent, value => get(value));
   }
}
